import 'videojs-markers';
import 'videojs-markers/dist/videojs.markers.css';

import { cloneDeep } from 'lodash';
import * as _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';

interface IProps {
  srcUrl: string;
  autoPlay?: boolean;
  disablePausing?: boolean;
  onTimeUpdate?: (currentTime: number) => void;
  markers?: any[];
  videoId?: string;
}

// var dummymarkers = [
//   {
//     time: 2,
//     text: "Chapter 1"
//   },
//   {
//     time: 6,
//     text:
//       "Chapter 2"
//   },
//   {
//     time: 23.6,
//     text: "Chapter 3"
//   },
//   {
//     time: 28,
//     text: "Chapter 4"
//   },
//   {
//     time: 36,
//     text: "Chapter 5"
//   }
// ];
const defaultVideoJsOptions = {
  autoplay: false,
  controls: true,
  responsive: true,
  fluid: true,
  sources: [
    {
      src: null,
      type: 'video/mp4',
    },
  ],
};

const SimplePlayer = ({
  srcUrl,
  autoPlay = false,
  disablePausing = false,
  onTimeUpdate = () => {},
  markers = [],
  videoId = 'player1',
}: IProps) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [videoJsOptions, setVideoJsOptions] = useState(cloneDeep(defaultVideoJsOptions));

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on('waiting', () => {
      videojs.log('player is waiting');
    });

    player.on('dispose', () => {
      videojs.log('player will dispose');
    });
  };

  const initialize = () => {
    // console.log('SimplePlayer init', { srcUrl, autoPlay });
    setTimeout(() => {
      const myVideoJSOptions = cloneDeep(defaultVideoJsOptions);
      myVideoJSOptions.sources = [
        {
          src: srcUrl,
          // type: 'application/x-mpegURL',
        },
      ];
      myVideoJSOptions.autoPlay = autoPlay;

      // Make sure Video.js player is only initialized once
      if (!playerRef.current) {
        const videoElement = videoRef.current;

        if (!videoElement) return;
        const player = (playerRef.current = videojs(videoElement, myVideoJSOptions, () => {
          videojs.log('player is ready');
          handlePlayerReady(player);
          addListeners(player);
        }));
        // Add new markers
        player.markers({
          markerStyle: {
            width: '8px',
            fontSize: '12px',
            'background-color': '#0db080',
          },
          markerTip: {
            display: false,
            style: {
              'font-size': '6px',
            },
            text(marker) {
              return marker.text || 'Marker';
            },
          },
          markers,
        });
        // You could update an existing player in the `else` block here
        // on prop change, for example:
      } else {
        const player = playerRef.current;

        // player.autoplay(options.autoplay);
        player.src(myVideoJSOptions.sources);
      }
    }, 0);
  };

  const addListeners = (player) => {
    player.on('timeupdate', () => {
      onTimeUpdate(player.currentTime());
    });
    player.on('error', (err) => {
      console.error('Player Error', err);
    });
  };

  useEffect(() => {
    if (srcUrl) initialize();

    return function cleanup() {
      // console.log('cleanup', { playerRef });
      if (playerRef && playerRef.current) {
        if (playerRef.current.dispose && _.isFunction(playerRef.current.dispose)) {
          // console.log('calling player dispose');
          playerRef.current.dispose();
        }
      }
    };
  }, []);

  return (
    <div className="simple-player" data-vjs-player>
      <video id={videoId} ref={videoRef} className="video-js vjs-big-play-centered" />
    </div>
  );
};

export default SimplePlayer;
